/**
 * 레퍼런스 : https://github.kakaocorp.com/kakaopage/api/blob/e7534bc8aa9241bd92cf046410ceed0bdb77268b/common/src/main/java/com/kakaopage/common/model/enums/ProductType.java#L19
 */
export enum ProductTypeVo {
  Single = 'PT01', // 단품
  SingleInSeries = 'PT02', // 시리즈내 단품
  Package = 'PT03', // 패키지
  FreeTicket = 'PT04', // 자유이용권
  Series = 'PT05', // 시리즈
  SeriesTicket = 'PT06', // 시리즈이용권
  Buy = 'PT07', // 소장이용권
  Rent = 'PT08', // 대여이용권
  Preview = 'PT09', // 먼저보기이용권
  Premium = 'PT10', // 프리미엄이용권
  WaitFree = 'PT11', // 기다리면무료이용권
  Web = 'PT12', // 웹 열람
  BuyVod = 'PT13', // 영화 소장 - 종료됨
  RentVod = 'PT14', // 영화 대여 - 종료됨
  WaitFreePlus = 'PT15', // 기다리면무료플러스이용권
}
